import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { FormDataService } from '../data.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { EmailService } from '../../../email/services/email.service';
import { formStatus } from '../../form.constants';
import { SweetAlertOptions } from 'sweetalert2';

@Injectable()
export class SendDeskAuditActionHandlerService extends FormActionHandlerService {
  constructor(
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private dataService: FormDataService,
    private swal: SwalService,
    private emailService: EmailService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;

    const swalOptions = <SweetAlertOptions>{
      title: 'Send the examination request to the applicant?',
      inputPlaceholder:
        'Enter your comments here. These comments will be included in the email to the applicant and saved to the form\'s status history.',
      type: 'question',
      confirmButtonText: 'Yes, Send Examination',
      allowOutsideClick: false
    };
    const swalEmptyInputErrorMessage =
      'Comments must be entered in order to proceed.';

    return new Promise((resolve, reject) => {
      that.swal
        .textarea(swalOptions, 'required', swalEmptyInputErrorMessage)
        .then(comments => {
          that.swal.load('Sending Examination...');

          that.statusService.changeStatus(formStatus.examinationSent);
          that.shareService.form.statuses[0].comment = comments;

          that.dataService.saveForm().subscribe(
            () => {
              const projectGuid = that.shareService.formId.projectGuid;

              that.emailService
                .sendRdExaminationRequestedEmail(
                  that.shareService.project,
                  projectGuid,
                  comments
                )
                .subscribe(
                  () => {
                    that.swal
                      .success({
                        title: 'Examination sent.',
                        text:
                          'The form is now Examination Sent and the applicant has been notified.'
                      })
                      .then(() => resolve())
                      .catch(() => resolve());
                  },
                  () => {
                    that.swal
                      .error({
                        title:
                          'Form updated, but the notification email could not be sent.',
                        text:
                          'The form is now Examination Sent. Please try notifying the applicant again.'
                      })
                      .then(() => resolve())
                      .catch(() => resolve());
                  }
                );
            },
            errorSaving => {
              if (errorSaving === 409) {
                reject(errorSaving);
              } else {
                reject(
                  'We were unable to update the form status. Please try again later.'
                );
              }
            }
          );
        })
        .catch(() => resolve());
    });
  }
}
